// アカウント設定（メアド・パスワード・退会・休眠・削除）まわりの文言
// ボタン
export const BTN_SIGNOUT = 'ログアウト';
export const BTN_UNSUBSCRIBE_PROCEDURE = '退会手続き';
export const BTN_DORMANT = '休眠会員になる';
// メールアドレス
export const EMAIL_EMPTY = 'メールアドレスを入力してください';
export const EMAIL_INVALID = '不正なメールアドレスです';
export const EMAIL_CHANGE_SUCCEEDED = '新しいメールアドレスに確認メールをお送りしました';
export const EMAIL_CHANGE_FAILED = 'メールアドレスの変更に失敗しました';
export const EMAIL_VERIFICATION_SUCCEEDED = 'メールアドレスを確認しました';
export const EMAIL_VERIFICATION_FAILED = 'メールアドレスを確認できませんでした';
export const FAILD_TO_GET_ME = 'ユーザー情報取得に失敗しました';
// パスワード
export const PASSWORD_EMPTY = 'パスワードを入力してください';
export const NEW_PASSWORD_EMPTY = '新しいパスワードを入力してください';
export const NEW_PASSWORD_CONFIRM_EMPTY = '新しいパスワード(確認)を入力してください';
export const NEW_PASSWORD_DOESNT_MATCH = '新しいパスワードと新しいパスワード(確認)が一致しません';
export const CUR_PASSWORD_EMPTY = '現在のパスワード入力してください';
export const PASSWORD_CHANGE_SUCCEEDED = 'パスワードを変更しました';
export const PASSWORD_CHANGE_FAILED = 'パスワードの変更に失敗しました';
export const PASSWORD_LENGTH = 'パスワードは6文字以上の英数字で入力してください';
export const PASSWORD_CONFIRM_ERR = 'パスワードが一致しません';
// 退会・休眠・復旧・削除
export const SCHEDULE_UNSUBSCRIBE_SUCCEEDED = '退会処理が完了しました。';
export const SCHEDULE_UNSUBSCRIBE_FAILED = '退会処理中にエラーが発生しました。\nお手数ですがサポートにお問い合わせください。';
export const CANCEL_UNSUBSCRIBE_SUCCEEDED = '退会処理が完了しました。';
export const CANCEL_UNSUBSCRIBE_FAILED = '退会取り消しに失敗しました。';
export const DORMANT_MEMBERSHIP_SUCCEEDED = '休眠会員処理が完了しました。';
export const DORMANT_MEMBERSHIP_FAILED = '休眠会員処理中にエラーが発生しました。\nお手数ですがサポートにお問い合わせください。';
export const ALREADY_DORMANT = 'あなたのアカウントは休眠アカウントになっています。';
export const ACCOUNT_ACTIVATED = 'おかえりなさい！一般会員に復旧しました。';
export const ACTIVATE_FAILED = '一般会員への復旧に失敗しました。';
export const ALREADY_UNSUBSCRIBED = 'すでに退会済みです。今回支払い分の期間まで、引き続きサービスをご利用いただけます。';
export const DESTROY_ACCOUNT_SUCCEEDED = 'アカウト削除が完了しました。';
export const DESTROY_ACCOUNT_FAILED = 'アカウント削除中に。\nお手数ですがサポートにお問い合わせください。';
